import React from 'react'
import ContainerNew from 'presentation/hospital/components/ContainerNew'
import ActiveSearchDetailsLayout from 'presentation/hospital/layouts/ActiveSearchDetails'
import { useStores } from 'presentation/hooks/use-stores'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'
import { ActiveSearchRepository } from 'repository/repositories/active-search/active-search-repository'
import { RemoteLoadActiveSearchType } from 'service/usecases/load-active-search-type/remote-load-active-search-type'
import { observer } from 'mobx-react'

const ActiveSearchDetails = observer(() => {
  const currentHospital = useStores().currentHospital.actualHospital

  // Jogar essas novas rotas dentro do service
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )
  const activeSearchRepository = new ActiveSearchRepository(apiRepository)
  const loadActiveSearchType = new RemoteLoadActiveSearchType(
    activeSearchRepository
  )
  return (
    <ContainerNew>
      <ActiveSearchDetailsLayout
        currentHospitalId={currentHospital!.hospital_id}
        loadActiveSearchType={loadActiveSearchType}
      />
    </ContainerNew>
  )
})

export default ActiveSearchDetails
